import './index.erb';
import './index.rb';

import './index.scss';
import 'images/questions/review.svg';

export default class QuestionsReviewSuggestionModal {
  constructor() {
    this.$context = $('#js-questions-review-suggestion-modal');
    this.$closeBtn = $('.js-close-btn', this.$context);
    this.bind();
    this.$context.animate({ bottom: 0 }, 'slow');
  }

  bind() {
    this.$closeBtn.click(() => this.$context.animate({ bottom: -157 }, 'slow'));
  }
}
